export class Regex {
  static isValidUsername = (username: string) =>
    /^[A-Z0-9._ ]{3,16}$/i.test(username);
}
